import React from 'react';
import { Calendar, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { noticias } from '../mock';

const UltimasNoticias = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-12">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Últimas Noticias</h2>
            <p className="text-gray-600 max-w-2xl">
              Mantente informado sobre las novedades y eventos más recientes de la SETY
            </p>
          </div>
          <Link
            to="/noticias"
            className="hidden md:flex items-center gap-2 px-6 py-3 bg-[#8B1538] text-white rounded-lg hover:bg-[#6B0F2A] transition-colors font-medium"
          >
            Ver Todas
            <ArrowRight className="h-5 w-5" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {noticias.map((noticia) => (
            <div
              key={noticia.id}
              className="group bg-white rounded-xl overflow-hidden border border-gray-200 hover:shadow-xl hover:border-gray-300 transition-all duration-300"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={noticia.imagen}
                  alt={noticia.titulo}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
              </div>
              
              <div className="p-6">
                <div className="flex items-center gap-2 text-sm text-gray-500 mb-3">
                  <Calendar className="h-4 w-4 text-[#8B1538]" />
                  <span>{noticia.fecha}</span>
                </div>
                
                <h3 className="text-lg font-semibold text-gray-900 mb-2 line-clamp-2 group-hover:text-[#8B1538] transition-colors">
                  {noticia.titulo}
                </h3>
                
                <p className="text-sm text-gray-600 mb-4 line-clamp-2">
                  {noticia.extracto}
                </p>
                
                <button className="text-sm font-medium text-[#8B1538] hover:text-[#6B0F2A] transition-colors flex items-center gap-2 group-hover:gap-3">
                  Leer más
                  <ArrowRight className="h-4 w-4" />
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center md:hidden">
          <Link
            to="/noticias"
            className="inline-flex items-center gap-2 px-6 py-3 bg-[#8B1538] text-white rounded-lg hover:bg-[#6B0F2A] transition-colors font-medium"
          >
            Ver Todas las Noticias
            <ArrowRight className="h-5 w-5" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default UltimasNoticias;